export const PROJECT_CATEGORY_ID = 1 as const;
